import * as moment from 'moment';
import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-sales-week-chart',
  templateUrl: './sales-week-chart.component.html',
  styleUrls: ['./sales-week-chart.component.scss']
})
export class SalesWeekChartComponent implements OnInit, OnDestroy {

  @ViewChild('editModal') editModal: TemplateRef<any>;
  @Input() section: any = false;
  changeModal$!: Subscription;
  changeModal;
  construction;
  data;
  productType = 'regular';
  productType$!: Subscription;
  reqst = 0;
  stationId$!: Subscription;
  stationId: any;
  traffic: any;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'line'
    },
    title: {
      text: 'Ventas por dia de la semana',
      style: {
        fontSize: '0'
      }
    },
    xAxis: {
      categories: [],
      gridLineWidth: 1,
      gridLineDashStyle: 'LongDash',
      title: {
        text: 'Fecha',
        style: {
          fontSize: '0'
        }
      },
      labels: {
        style: {
          fontSize: '11px',
        },
        y: 14
      }
    },
    yAxis: {
      title: {
        text: ''
      },
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value as number, 0, '.', ',') + ' Lts.';
        },
        style: {
          fontSize: '11px'
        }
      },
      tickAmount: 10,
      gridLineDashStyle: 'LongDash'
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
      itemDistance: 10,
      y: 1,
      padding: 1,
      itemMarginTop: 1,
      itemMarginBottom: 1,
      itemHoverStyle: {
        color: '#00E07B',
      }
    },
    tooltip: {
      split: true
    },
    plotOptions: {
      series: {
        animation: {
          duration: 1000
        },
        marker: {
          radius: 3,
          symbol: 'circle',
        },
        lineWidth: 1
      }
    },
    exporting: {
      filename: 'Ventas por dia de la semana',
      sourceWidth: 1200,
      sourceHeight: 800
    },
    navigation: {
      buttonOptions: {
        align: 'right',
        y: -18
      }
    },
    series: []
  };

  constructor(
    private gasprecioService: GasprecioService,
    private sharedService: SharedService
  ) {
    this.stationId = localStorage.getItem('idStation');
    this.productType$ = this.sharedService.sharedProductType.subscribe(productType => {
      if (this.productType !== productType) {
        this.productType = productType;
        if (this.reqst > 1) {
          this.setData();
        }
      }
    });

    this.stationId$ = this.sharedService.sharedStationId.subscribe(stationId => {
      if (this.stationId !== stationId) {
        this.stationId = stationId;
      }
    });

    this.changeModal$ = this.sharedService.sharedChangeModal.subscribe(changeModal => {
      this.changeModal = changeModal;
      if (this.changeModal === 'charts') {
        this.getChartSales();
      }
    });
  }

  async ngOnInit() {
    if (this.section) {
      this.getChartSales();
    }
  }

  ngOnDestroy(): void {
    this.productType$.unsubscribe();
    this.stationId$.unsubscribe();
    this.changeModal$.unsubscribe();
  }

  getChartSales() {
    this.reqst = 1;
    if (this.section) {
      this.stationId = localStorage.getItem('idStation');
    }
    if (this.stationId === '' || this.stationId === null) {
      return;
    }

    this.gasprecioService.getSalesByWeek(this.stationId).subscribe({
      next: (data: any) => {
        this.data = data;
      this.setData();
    }, complete: () => {
      this.reqst = 2;
    }, error: () => {
      this.reqst = 3;
    }
    });
  }

  setData() {
    this.reqst = 1;
    const lineChartData: any = [];
    // Opcion 1
    const lineColors = [
      "#2ca02c",
      "#1f77b466",
      "#ff7f0e66",
      "#d6272866",
      "#9467bd66"
    ];

    // Opcion 2
    // const lineColors = ['#2E86AB', '#F6C85F', '#6F4E7C', '#9DD866', '#CA472F']

    // Opcion 3
    // const lineColors = ['#4E79A7', '#F28E2B', '#E15759', '#76B7B2', '#59A14F']

    // Opcion 4
    // const lineColors = ['#5F9ED1', '#ED7D31', '#A5A5A5', '#70AD47', '#FFC000']

    let lineXaxisLegend = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];

    Object.entries(this.data).forEach((weeks, index) => {
      const weekData = this.data[weeks[0]];
      const chartData = {
        name: index === 0 ? 'Sem Actual' : 'Sem -' + index,
        data: lineXaxisLegend.map(d => weekData?.[d]?.[this.productType].sales ?? null),
        lineWidth: 2,
        marker: {
          radius: 3
        },
        tooltip: {
          pointFormatter: function () {
            const formatted = Highcharts.numberFormat(this.y as number, 0, '.', ',');
            return '<b>' + this.series.name + ': ' + formatted + ' lts.</b>';
          }
        },
        cursor: 'pointer',
        color: lineColors[index],
        dashStyle: index == 0 ? 'Solid' : 'ShortDot',
      }
      lineChartData.push(chartData);
    })

    const forecastSeries: Highcharts.SeriesLineOptions = {
      type: 'line',
      name: 'Venta Pronosticada',
      data: lineXaxisLegend.map(d => this.data.week_offset_0?.[d]?.[this.productType].forecast_sales ?? null),
      lineWidth: 2,
      marker: { radius: 3, symbol: 'square' },
      color: 'rgb(212, 175, 55)',
      zIndex: 10,
      tooltip: {
        pointFormatter: function () {
          const formatted = Highcharts.numberFormat(this.y as number, 0, '.', ',');
          return `<b>${this.series.name}: ${formatted} lts.</b>`;
        }
      },
    };

    lineChartData.unshift(forecastSeries);
    lineXaxisLegend = lineXaxisLegend.map(day => day.charAt(0).toUpperCase() + day.slice(1));
    (this.chartOptions as any).componentRef = this;
    this.chartOptions['xAxis']['categories'] = lineXaxisLegend;
    this.chartOptions['series'] = lineChartData;
    this.chartOptions['legend'] = {
      ...(this.chartOptions.legend as Highcharts.LegendOptions),
      itemDistance: 8,
      symbolPadding: 4,
      itemMarginTop: 5,
      itemMarginBottom: 0,
      useHTML: true,
      labelFormatter: function (this: Highcharts.Series) {

        if (this.name === 'Venta Pronosticada') {
          return this.name;
        }
        const comp = (this.chart.options as any).componentRef || (this.chart.userOptions as any)?.componentRef;
        const range = comp?.getWeekRange?.(this.name) ?? '';

        return `
          <span style="display:flex;align-items:center;gap:4px;">
            ${this.name}
            <i class="fa fa-info-circle" aria-hidden="true"
              style="color:#9b9b9b;cursor:pointer;"
              title="${range}"></i>
          </span>
        `;
      }
    },
    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }

  getWeekRange(name: string): string {
    const today = moment().tz("America/Mexico_City").startOf("day");

    if (name === "Sem Actual") {
      const start = today.clone().startOf("week").format("ddd DD");
      const end = today.clone().format("ddd DD");
      return `${start} a ${end}`;
    }

    const match = name.match(/Sem -(\d+)/);
    if (match) {
      const offset = parseInt(match[1], 10);
      const start = today.clone().subtract(offset, "weeks").startOf("week").format("ddd DD");
      const end = today.clone().subtract(offset, "weeks").endOf("week").format("ddd DD");
      return `${start} a ${end}`;
    }

    return "";
  }
}

